import React from "react";
import { useSelector } from "react-redux";
import { UserContextSelectors } from "../../redux/selectors/index.js";
import { AppFeatures } from "../../constants/featureFlags.js";
import { useFeature } from "../../hooks/useFeature.js";
import { LazyLoadUtils } from "../../utils/index.js";

const ControlCenterHeaderButtonLoadableComponent =
  LazyLoadUtils.lazyWithFallback(
    () =>
      import(
        /* webpackChunkName: "control-center/header-button" */ "./components/ControlCenter.headerButton.js"
      ),
    { componentName: "ControlCenterHeaderButton" }
  );

export const ControlCenterHeaderButtonLoadable = () => {
  const isControlCenterActive = useFeature(
    AppFeatures.CONTROL_CENTER,
    AppFeatures.SAFEZONE_GENERIC
  );

  return isControlCenterActive ? (
    <ControlCenterHeaderButtonLoadableComponent />
  ) : null;
};

const ControlCenterDataLoadableComponent = LazyLoadUtils.lazyWithFallback(
  () =>
    import(
      /* webpackChunkName: "control-center/data" */ "./components/ControlCenter.data.js"
    ),
  { componentName: "ControlCenterData" }
);

export const ControlCenterDataLoadable = () => {
  const isAuthenticated = useSelector(UserContextSelectors.isAuthenticated);
  const isControlCenterActive = useFeature(
    AppFeatures.CONTROL_CENTER,
    AppFeatures.SAFEZONE_GENERIC
  );

  const shouldLoad = isAuthenticated && isControlCenterActive;

  return shouldLoad ? <ControlCenterDataLoadableComponent /> : null;
};
